module.exports = __webpack_public_path__ + "img/403-bed.25eb8d47.jpeg";